import * as React from 'react';
import { components } from '@doltech/dto';
import { VocabExampleComponent } from './VocabExampleComponent';

export interface VocabListProps {
  vocabList: components['schemas']['VocabDTO'][];
  pageUrl?: string;
}

export const VocabList = ({ vocabList }: VocabListProps) => {
  const renderVocabList = React.useCallback((list) => {
    return (list || []).map((vocab, vocabIndex) => {
      return <VocabExampleComponent key={vocab.pronounce + vocabIndex} {...vocab} />;
    });
  }, []);

  return <div className="vocab-list">{renderVocabList(vocabList)}</div>;
};
